import React from 'react';

const STEPS = [
  { key: 'searching', id: 1, tk: 'active.stepSearch' },
  { key: 'driver_assigned', id: 2, tk: 'active.stepAssigned' },
  { key: 'arrived', id: 3, tk: 'active.stepArrived' },
  { key: 'started', id: 4, tk: 'active.stepTrip' },
  { key: 'completed', id: 5, tk: 'active.stepDone' },
];

const AutoStepIcon = () => (
  <svg width="15" height="15" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M88 15H18C10 15 4 21 4 29V66C4 70 7 73 11 73H13" />
    <path d="M29 73H72" />
    <path d="M38 18V46C38 52 42 56 48 56H64V18" />
    <path d="M68 18V44H84L78 18H68Z" />
    <circle cx="21" cy="76" r="9" fill="currentColor" />
    <circle cx="87" cy="78" r="9" fill="currentColor" />
  </svg>
);

function RideProgress({ status, timestamps = {}, t = (k) => k }) {
  let currentIdx = STEPS.findIndex((s) => s.key === status);
  if (status === 'cancelled') currentIdx = -1;
  else if (currentIdx < 0) currentIdx = 0;

  if (status === 'cancelled') {
    return null;
  }

  return (
    <div className="active-stepper-wrap" aria-label={t('active.rideProgress')}>
      <div className="active-stepper-track">
        {STEPS.map((step, i) => {
          const isDone = i < currentIdx;
          const isCurrent = i === currentIdx;
          // Only show timestamp if the step has been reached or passed
          const time = (isDone || isCurrent) ? timestamps[step.key] : null;

          return (
            <React.Fragment key={step.key}>
              <div className={`stepper-node${isDone ? ' done' : ''}${isCurrent ? ' current' : ''}`}>
                <div className="stepper-circle">
                  {isDone && <span className="stepper-check">✓</span>}
                  {isCurrent && (step.key === 'driver_assigned' || step.key === 'started' ? <AutoStepIcon /> : (isDone ? '✓' : step.id))}
                  {!isDone && !isCurrent && <span>{step.id}</span>}
                </div>
                <span className="stepper-label">{t(step.tk)}</span>
                {time && <span className="stepper-time">{time}</span>}
              </div>
              {i < STEPS.length - 1 && (
                <div className={`stepper-connector${i < currentIdx ? ' done' : ''}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

const sameStamps = (a = {}, b = {}) => ['searching', 'driver_assigned', 'arrived', 'started', 'completed']
  .every((k) => a[k] === b[k]);

export default React.memo(RideProgress, (prev, next) => (
  prev.status === next.status && prev.t === next.t && sameStamps(prev.timestamps, next.timestamps)
));

